import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { Button, PrimaryButton } from "components/Button";
import { Form } from "auth/components";
import { fadeInRule } from "utils/animations";
import { resetState } from "auth/modules/sign-up";

const Container = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin-bottom: 15px;
  }

  animation: ${fadeInRule};
`;

const Title = styled.div`
  font-size: 21px;
  line-height: 32px;
  text-align: center;
`;

const Copy = styled.div`
  font-size: 13px;
  line-height: 20px;
  text-align: center;
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  width: 100%;
`;

const SignUpExistingUser = ({ email, resetState }) => {
  return (
    <Form>
      <Container>
        <Title>
          We’ve noticed you’re already using another SolarWinds Cloud product
        </Title>

        <Copy>
          No need to sign up for an additional account. Log in with your
          existing credentials to get instant access to AppOptics, Loggly,
          Papertrail, and/or Pingdom!
        </Copy>

        <a href="/users/auth/swicus">
          <StyledPrimaryButton>Login as {email}</StyledPrimaryButton>
        </a>

        <Button onClick={() => resetState()}>
          Sign-up with a different e-mail address
        </Button>
      </Container>
    </Form>
  );
};

function mapStateToProps(state, props) {
  return {
    email: state.signUp.email,
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    resetState: () => dispatch(resetState()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpExistingUser);
